var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Landing",
    { staticClass: "landing" },
    [
      _c("LandingHeaderV2", {
        attrs: {
          "ax-params": {
            ids: {
              headerLogInBtn: "clicked_log_in_from_landing_header",
              stickyHeaderSignUpBtn:
                "clicked_get_started_from_landing_sticky_header",
              stickyHeaderLogInBtn: "clicked_log_in_from_landing_sticky_header"
            },
            extra: {
              general_path_id: _vm.generalPath.id
            }
          },
          isMathcounts: _vm.isMathcounts
        }
      }),
      _vm._v(" "),
      _c(
        "LandingHeroV2",
        {
          class: { "default-video": !_vm.generalPath.hero_video_url },
          attrs: {
            "video-url": _vm.heroVideoUrl,
            "cta-ax-params": {
              axId: "clicked_get_started_from_landing",
              axType: "button",
              axExtra: {
                general_path_id: _vm.generalPath.id
              }
            },
            isMathcounts: _vm.isMathcounts
          }
        },
        [
          _c("span", {
            staticClass: "title",
            attrs: { slot: "header" },
            domProps: { innerHTML: _vm._s(_vm.title) },
            slot: "header"
          }),
          _vm._v(" "),
          _c("span", {
            attrs: { slot: "intro-text" },
            domProps: { innerHTML: _vm._s(_vm.generalPath.description) },
            slot: "intro-text"
          })
        ]
      ),
      _vm._v(" "),
      _vm.show_sponsor_modal ? _c("SponsorModal") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "divider" })
      ]),
      _vm._v(" "),
      _c("GeneralPathCourses", {
        attrs: {
          courses: _vm.generalPath.courses,
          isMathcounts: _vm.isMathcounts
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "divider" })
      ]),
      _vm._v(" "),
      _c("Recognition"),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "divider" })
      ]),
      _vm._v(" "),
      _c("LearningPaths", { attrs: { "ax-id-prefix": "landing_page" } }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "divider" })
      ]),
      _vm._v(" "),
      _c("JoinCTA", {
        attrs: {
          "btn-ax-id": "clicked_get_started_from_landing_footer",
          isMathcounts: _vm.isMathcounts,
          href: _vm.ctaHref
        }
      }),
      _vm._v(" "),
      _c("LandingFooter")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }